const optionRole = [
    { value: 'programmer', label: 'Programmer' },
    { value: 'system_analyst', label: 'System Analyst' },
    { value: 'support_system', label: 'Support System' },
    { value: 'technical_writer', label: 'Technical Writer' },
    { value: 'tester', label: 'Tester' },
];

export { optionRole };
